import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'tOnlyDateFormatPipe',
})
export class TOnlyDateFormatPipe implements PipeTransform {
    transform(value: any) {
        let now = new Date();
        let to_date = new Date(value);
        let datePipe = new DatePipe('en-US');
        value = datePipe.transform(value, 'dd/MM/yyyy');
        return value;
    }
}